import React from 'react';
import styles from './Footer.module.css';
import { SOCIAL_LINKS, APP_LINKS, LEGAL_LINKS, BRAND } from '../../constants/socialLinks';

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerLeft}>
          <img src={BRAND.logo} alt={BRAND.name} className={styles.footerLogo} />
          <p className={styles.copyright}>&copy; {new Date().getFullYear()} {BRAND.name}. All rights reserved.</p>
        </div>
        <div className={styles.footerRight}>
          <div className={styles.legalLinks}>
            <a href={LEGAL_LINKS.termsOfService} className={styles.legalLink}>Terms of Service</a>
            <a href={LEGAL_LINKS.privacyPolicy} className={styles.legalLink}>Privacy Policy</a>
            <a href={LEGAL_LINKS.refundPolicy} className={styles.legalLink}>Refund Policy</a>
          </div>
          <div className={styles.socialLinks}>
            <a href={SOCIAL_LINKS.discord.url} target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
              <img src={SOCIAL_LINKS.discord.icon} alt={SOCIAL_LINKS.discord.label} />
            </a>
            <a href={SOCIAL_LINKS.instagram.url} target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
              <img src={SOCIAL_LINKS.instagram.icon} alt={SOCIAL_LINKS.instagram.label} />
            </a>
            <a href={SOCIAL_LINKS.tiktok.url} target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
              <img src={SOCIAL_LINKS.tiktok.icon} alt={SOCIAL_LINKS.tiktok.label} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
